module.exports = __webpack_public_path__ + "static/media/comanda-mobile.5c87d648.png";